module.exports = __webpack_public_path__ + "static/media/VaccineIcon.c50cb63f.svg";